import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c63301c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backgrnd" }
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Mi Perfil ", -1))
const _hoisted_6 = { class: "container mt-5" }
const _hoisted_7 = { class: "row d-flex justify-content-center" }
const _hoisted_8 = { class: "col-md-7" }
const _hoisted_9 = { class: "card p-3 py-4" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "text-center mt-3" }
const _hoisted_13 = { class: "mt-2 mb-0" }
const _hoisted_14 = { class: "px-4 mt-1" }
const _hoisted_15 = { class: "fonts" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { id: "imageForm" }
const _hoisted_18 = { class: "list-group" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file",
  _mstvisible: "2"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Evaluaciones ")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        ($data.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "img",
                src: 
            'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
          
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.selectImage && $options.selectImage(...args))),
                  src: 
                    `https://cruzjiminian-assets-bucket.s3.amazonaws.com/usuario-${this.$store.state.user.username}.jpg`
                  ,
                  width: "100",
                  class: "rounded-circle"
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h5", _hoisted_13, _toDisplayString(this.$store.state.user.usuario), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(this.$store.state.user.username) + " | " + _toDisplayString(this.$store.state.user.email), 1)
                ]),
                _hoisted_16,
                _createElementVNode("div", null, [
                  _createElementVNode("form", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      id: "imageInput",
                      type: "file",
                      ref: "fileInput",
                      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.uploadFile && $options.uploadFile(...args))),
                      accept: "image/*"
                    }, null, 544), [
                      [_vShow, false]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.entities, (entidad, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "list-group-item d-flex justify-content-between align-items-center"
                  }, [
                    _createElementVNode("a", {
                      class: "navbar-option",
                      onClick: ($event: any) => (this.$router.push(entidad.formRoute)),
                      href: "#"
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(entidad.icon)
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(entidad.nombre), 1)
                    ], 8, _hoisted_19)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      (this.$store.state.user.type == 'NUTRIMED')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$router.push('/evaluacions'))),
            class: "btn btn-success btn-sm",
            type: "button"
          }, _hoisted_22))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !$data.cargando]
    ])
  ]))
}